import type { ChatMessage } from './domain';
import type { ApiWidget } from './api';

export interface ChatWidgetProps<TData = any> {
  message: ChatMessage;
  data: TData;
  isDisabled?: boolean;
  onSendMessage?: (content: string) => void;
  onAction?: (actionType: string, actionData?: any) => void;
}

export type ChatWidgetComponent<TData = any> = React.FC<ChatWidgetProps<TData>>;

export interface WidgetRegistration<TData = any> {
  widgetType: string;
  component: ChatWidgetComponent<TData>;
  displayName: string;
}

export class ChatWidgetRegistry {
  private readonly widgets: Map<string, WidgetRegistration> = new Map();

  register<T extends ApiWidget>(registration: WidgetRegistration<T>): void {
    if (this.widgets.has(registration.widgetType)) {
      console.warn(`Widget type "${registration.widgetType}" is already registered. Overwriting.`);
    }
    this.widgets.set(registration.widgetType, registration);
  }

  get(widgetType: string): WidgetRegistration | undefined {
    return this.widgets.get(widgetType);
  }

  has(widgetType: string): boolean {
    return this.widgets.has(widgetType);
  }

  getAllTypes(): string[] {
    return Array.from(this.widgets.keys());
  }

  getAll(): WidgetRegistration[] {
    return Array.from(this.widgets.values());
  }

  unregister(widgetType: string): boolean {
    return this.widgets.delete(widgetType);
  }

  clear(): void {
    this.widgets.clear();
  }
}

export const chatWidgetRegistry = new ChatWidgetRegistry();
